import {
    provideHttpClient,
    withInterceptorsFromDi,
    withXhr,
} from '@angular/common/http';
import {
    NgModule,
    Optional,
    SkipSelf,
} from '@angular/core';
import type { ModuleWithProviders } from '@angular/core';
import { environment } from '../../environments/environment';

@NgModule({
    imports: [environment.auth.module],
    providers: [
        ...environment.auth.interceptors,
        ...environment.auth.providers,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() core: CoreModule) {
        if (core) {
            throw new Error('Core module cannot be imported multiple times!');
        }
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
        };
    }
}
